import { MessageActionTypes } from './message.types';

const INITIAL_STATE = {
  value: '',
  subject: '',
  html: '',
  id: '',
  type: 'Text',
  error: null,
  messageData: null,
};

const messageReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MessageActionTypes.SET_MESSAGE:
      return { ...state, value: action.payload };

    case MessageActionTypes.SET_MESSAGE_TYPE:
      return { ...state, type: action.payload };

    case MessageActionTypes.SET_MESSAGE_SUBJECT:
      return { ...state, subject: action.payload };

    case MessageActionTypes.SET_MESSAGE_HTML:
      return { ...state, html: action.payload };

    case MessageActionTypes.SET_MESSAGE_TEMPLATE_ID:
      return { ...state, id: action.payload };

    case MessageActionTypes.SET_MESSAGE_DATA:
      return { ...state, messageData: action.payload };

    case MessageActionTypes.CLEAR_MESSAGE:
      return { ...INITIAL_STATE };

    case MessageActionTypes.SEND_EMAIL_FAILURE:
    case MessageActionTypes.SEND_TEXT_FAILURE:
      return { ...state, error: action.payload };

    case MessageActionTypes.SEND_EMAIL_SUCCESS:
    case MessageActionTypes.SEND_TEXT_SUCCESS:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default messageReducer;
